// ProtectWorkSection.jsx (CSS Animations Version)

const ShieldIcon = ({ className = "w-7 h-7 text-white" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const LockIcon = () => (
  <svg
    className="w-[22px] h-[22px] text-[#1A3F5C]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const EyeIcon = () => (
  <svg
    className="w-[22px] h-[22px] text-[#2563EB]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const RefreshIcon = () => (
  <svg
    className="w-[22px] h-[22px] text-[#2D7A4F]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

const cards = [
  {
    icon: <LockIcon />,
    bg: "linear-gradient(135deg,#e8ecf0 0%,#dde3ea 100%)",
    titleColor: "text-[#1A3F5C]",
    title: "Smart access control",
    desc: "Team members can only see and do what they're supposed to.",
  },
  {
    icon: <ShieldIcon className="w-[22px] h-[22px] text-[#4A4A9E]" />,
    bg: "linear-gradient(135deg,#ebe8f5 0%,#e0dbf0 100%)",
    titleColor: "text-[#0D1B2A]",
    title: "Protected storage",
    desc: "Your data is locked up tight, whether it's sitting in storage or being sent.",
  },
  {
    icon: <EyeIcon />,
    bg: "linear-gradient(135deg,#e4eaf7 0%,#d8e2f5 100%)",
    titleColor: "text-[#0D1B2A]",
    title: "Privacy matters",
    desc: "We collect only what's needed and keep clear lines about who owns what.",
  },
  {
    icon: <RefreshIcon />,
    bg: "linear-gradient(135deg,#e4f0e8 0%,#d8ebe0 100%)",
    titleColor: "text-[#0D1B2A]",
    title: "Always reliable",
    desc: "Automatic backups and systems designed to stay up and running.",
  },
];

export default function ProtectWorkSection() {
  return (
    <section
      className="protect-work-section flex flex-col items-center justify-center px-6 py-20 overflow-hidden"
      style={{ background: "linear-gradient(180deg,#f0f3f7 0%,#f7f9fb 100%)" }}
    >
      <style>{`
        .card {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: 1px solid transparent;
          background-clip: padding-box;
        }

        .card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
          border-color: transparent;
        }

        .card-icon {
          transition: all 0.3s ease;
        }

        .card:hover .card-icon {
          transform: scale(1.1) rotate(5deg);
        }

        .card-title {
          transition: transform 0.2s ease;
        }

        .card:hover .card-title {
          transform: translateX(4px);
        }
      `}</style>

      <div
        className="w-16 h-16 rounded-[16px] flex items-center justify-center mb-6"
        style={{
          background: "linear-gradient(145deg,#1E3A5F,#0F2A47)",
          boxShadow: "0 4px 20px rgba(15,42,71,0.25)",
        }}
      >
        <ShieldIcon />
      </div>

      <h2 className="ProtectWorkSection_Heading">How we protect your work</h2>

      <p className="ProtectWorkSection_Para">
        Security designed for real teams with real work
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 w-full max-w-[1060px]">
        {cards.map(({ icon, bg, titleColor, title, desc }) => (
          <div
            key={title}
            className="ProtectWorkSection_Card card"
            style={{ background: bg }}
          >
            <div className="card-icon w-[52px] h-[52px] bg-white rounded-[14px] flex items-center justify-center shadow-[0_1px_6px_rgba(0,0,0,0.06)]">
              {icon}
            </div>

            <div>
              <h3 className={`card-title ProtectWorkSection_title ${titleColor}`}>
                {title}
              </h3>
              <p className="ProtectWorkSection_desc">{desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
